import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PostProductStepService } from "../../services/post-product-step.service";
import { FormValidatorService } from "../../../../../shared/services/form-validator.service";
import { ProductTypes } from "../../../../../shared/product/productTypes";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../../../../shared/services/language.service";
import { BaseProduct } from "src/app/shared/product/baseProduct";
import { QuickPaymentStepOneComponent } from "./quick-payment-step-one/quick-payment-step-one.component";
import { QuickPaymentExtraInfoComponent } from "./quick-payment-extra-info/quick-payment-extra-info.component";
declare let $: any;
@Component({
  selector: 'app-quick-payment',
  templateUrl: './quick-payment.component.html',
  styleUrls: ['./quick-payment.component.scss']
})
export class QuickPaymentComponent extends BaseProduct implements OnInit,AfterViewInit {
  @ViewChild(QuickPaymentExtraInfoComponent)
 QuickPaymentExtraInfo!: QuickPaymentExtraInfoComponent;
 @ViewChild(QuickPaymentStepOneComponent)
 QuickPaymentStepOne!: QuickPaymentStepOneComponent;
 currentStep;
 listCurrentIcon: string = '../../../../../assets/icons/list.svg';
 responsiveCurrentIcon: string = '../../../../../assets/icons/responsive.svg';
 globeCurrentIcon: string = '../../../../../assets/icons/globe.svg';
 listIcon: string = '../../../../../assets/icons/list-muted.svg';
 responsiveIcon: string = '../../../../../assets/icons/responsive-muted.svg';
 globeIcon: string = '../../../../../assets/icons/globe-muted.svg';
  formValidator;
  stepForm!: FormGroup;
  isSubmitting: boolean = false;

  productTypeId: any;
  isUpdate: any;
  productName: string='QuickPayment';
  constructor(
    private postStep: PostProductStepService,
    private router: Router,
    dialog: MatDialog,
    public translate: TranslateService,
    private languageService: LanguageService
  ) {

   super(null, null, dialog);
    this.formValidator = new FormValidatorService();
  }
  ngAfterViewInit(): void {
       this.forms = [
         this.QuickPaymentStepOne,
         this.QuickPaymentExtraInfo,
       ]
     }
   ;

  ngOnInit() {
    this.translate.use(localStorage.getItem("language"));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });

  }

  async submit() {
    try {
      this.isSubmitting = true;
      let productValues = {
        ...this.QuickPaymentStepOne.stepForm.value,
        Currency: this.QuickPaymentStepOne.stepForm.controls['Viewing Currency'].value,
        type: ProductTypes.quickPayment
      }
      delete productValues['Viewing Currency'];
      let buyerInfos =
        this.QuickPaymentExtraInfo.stepForm.controls['buyerInfos'].value ||
        productValues['buyerInfos'];
      let thereIsDublickts =
        this.QuickPaymentExtraInfo.FormBuilder.dublicetIndex > -1;
      let defaultBuyerInfos = [
        { id: "", fieldName: "Name", fieldRequired: true, fieldType: "1", value: [] },
        { id: "", fieldName: "Email", fieldRequired: true, fieldType: "1", value: [] },
        { id: "", fieldName: "Phone", fieldRequired: true, fieldType: "1", value: [] },
      ];
      if (thereIsDublickts) {
        thereIsDublickts = !thereIsDublickts;
      }
      productValues["buyerInfos"] = [
        ...buyerInfos,
        ...defaultBuyerInfos,
      ];
      productValues['Payment options'] = [
        { id: 2,isSelected: true },
        { id: 3,isSelected: true },
        { id: 4,isSelected: true },
      ];
      productValues["Do you want the VAT to be on buyer?"] = !productValues["Do you want the VAT to be on buyer?"];
      this.postStep.setParams(productValues)
      let result = await this.postStep.make()

      let url = (await window.location.origin) + '/' + result.product.code;
      // await this.openCongratulationDialoug(url, productValues['name'], ProductTypes.quickPayment);
      // await this.router.navigateByUrl(result.product.code);
      window.location.href = result.product.code + "?showWindow=" + (this.isUpdate ? "update" : "create");
      //window.location.reload();
      this.isSubmitting = false;
    } catch (error) {
      this.isSubmitting = false;
    }
  }

  async goToStep(order: any) {
      let steps;
      if (order < this.currentStep) {
        steps = this.currentStep - order;
        for (let i = steps; i > 0; i--) {
          this.navigateToStep('prev');
        }
  } else if (order > this.currentStep) {
        steps = order - this.currentStep;
        for (let i = steps; i > 0; i--) {
          this.navigateToStep('next');
        }
      }
    }

  async navigateToStep(navigation: string) {
      if (this.isCurrentStepValid()) {
        const isBeforeTheLastStep = this.isStepBeforeBuyerInfoStep();
        if (isBeforeTheLastStep) {
          this.getBuyerInfoTogglerChoice();
          if (!this.canGoToBuyerInfoStep && navigation == 'next') {
            await this.submit();
          } else {
            if (navigation == 'next') {
              ++this.currentStep;
            } else {
              --this.currentStep;
            }
            $('html, body').animate({
              scrollTop: 0,
            });
          }
        } else {
          if (navigation == 'next') {
            ++this.currentStep;
          } else {
            --this.currentStep;
          }
          $('html, body').animate({
            scrollTop: 0,
          });
        }
      } else {
        if (navigation == 'prev') {
          --this.currentStep;
        }
        $('html, body').animate({
          scrollTop: 0,
        });
      }
    }
  convertControls(name: string) {
    return this.stepForm.get(name) as FormControl;
  }
}
